import TAGSORT from '../class/tagsortShared';

const [d, w] = [document, window];

let listenerBound = false;

const DEFAULT_API_ORIGIN = 'https://iwata.websapo.jp';
const LOG = '[sitemap-remote]';

/** sitemap.tpl の `({if $smarty.foreach.entry.index < 20 })` に合わせる窓の幅（ENTRY 先頭 N 件×カテゴリ一致） */
const ENTRY_WINDOW_SIZE = 20;

/** 取得件数の安全上限（一覧 API の負荷軽減） */
const MAX_FETCH = 400;

function debugEnabled() {
  try {
    if (w.sessionStorage?.getItem('SITEMAP_DEBUG') === '1') return true;
    return /[?&]sitemap_debug=1(?:&|$)/.test(w.location.search || '');
  } catch {
    return false;
  }
}

function log(...args) {
  if (debugEnabled()) console.info(LOG, ...args);
}

function normalizeArticleList(raw) {
  if (Array.isArray(raw)) return raw;
  if (raw && Array.isArray(raw.articles)) return raw.articles;
  if (raw && Array.isArray(raw.items)) return raw.items;
  return [];
}

function normalizeCategories(raw) {
  if (Array.isArray(raw)) return raw;
  return [];
}

function articleId(row) {
  if (!row || typeof row !== 'object') return '';
  const v = row.id ?? row.post_id ?? row.rec_no ?? row.REC_NO;
  return v != null && String(v) !== '' ? String(v) : '';
}

function isSitemapPage() {
  const path = location.pathname.replace(/\/$/, '') || '/';
  if (/sitemap\.php$/i.test(path)) return true;
  try {
    return new URLSearchParams(location.search).get('FUNC') === 'sitemap';
  } catch {
    return false;
  }
}

function escapeAttr(s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function escapeText(s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

/** TAGSORT.initialize の optimize と同等：記事にカテゴリ表示用オブジェクトを付与 */
function enrichArticles(articles, categories, moduleTitle) {
  const cats = normalizeCategories(categories);
  const sonota = {
    id: '0',
    name: 'その他',
    href: `/${moduleTitle}/?mode=list&cat=0`,
  };
  return normalizeArticleList(articles)
    .slice(0, MAX_FETCH)
    .map((article) => {
      const rawCat =
        article.category && typeof article.category === 'object' && article.category.id != null
          ? String(article.category.id)
          : String(article.category ?? '0');
      let meta;
      if (rawCat === '0') {
        meta = sonota;
      } else {
        const m = cats.find((c) => String(c.id) === rawCat);
        meta = m
          ? {
              id: String(m.id),
              name: m.name != null ? String(m.name) : '',
              href:
                m.href ||
                `/${moduleTitle}/?mode=list&cat=${encodeURIComponent(String(m.id))}`,
            }
          : sonota;
      }
      return { ...article, _sitemapCat: meta };
    });
}

function buildArticleLis(moduleTitle, list) {
  return list
    .map((a) => {
      const id = articleId(a);
      const title = a.title != null ? String(a.title) : '';
      const href = `/${encodeURIComponent(moduleTitle)}/?mode=detail&article=${encodeURIComponent(id)}`;
      return `<li class="rwd002-sitemap-article__item"><a href="${href}" title="${escapeAttr(title)}">${escapeText(title)}</a></li>`;
    })
    .join('');
}

function catIdOf(a) {
  return String(a._sitemapCat?.id ?? '0');
}

/** Hayabusa sitemap.tpl: 先頭 WINDOW 件のうち、指定カテゴリの行だけ（並びは ENTRY 相当＝API の並びのまま） */
function rowsForCategoryInWindow(windowRows, cid) {
  return windowRows.filter((a) => catIdOf(a) === String(cid));
}

/**
 * カテゴリ API あり → お知らせ型（h5 + ul）
 * カテゴリ API なし → 料金型（単一 ul）
 * 件数は sitemap.tpl 同等：並びの先頭 ENTRY_WINDOW_SIZE 件の窓 × カテゴリ一致。
 */
function buildModuleSitemapHtml(moduleTitle, articles, categories) {
  const enriched = enrichArticles(articles, categories, moduleTitle).filter((a) => articleId(a));
  if (!enriched.length) return '';

  const catList = normalizeCategories(categories);

  const appendBlock = (catId, catName, rowsForLis) => {
    const lis = buildArticleLis(moduleTitle, rowsForLis);
    if (!lis) return;
    const listHref = `/${encodeURIComponent(moduleTitle)}/?mode=list&cat=${encodeURIComponent(catId)}`;
    const nameEsc = escapeText(catName);
    const nameAttr = escapeAttr(catName);
    parts.push(`<ul class="rwd002-sitemap-category">
  <li class="rwd002-sitemap-category__item">
    <h5 class="rwd002-sitemap-category__title"><a href="${listHref}" title="${nameAttr}">${nameEsc}</a></h5>
    <ul class="rwd002-sitemap-article">
      ${lis}
    </ul>
  </li>
</ul>`);
  };

  const appendFlat = (rowsForLis) => {
    const lis = buildArticleLis(moduleTitle, rowsForLis);
    if (!lis) return;
    parts.push(`<ul class="rwd002-sitemap-category">
  <li class="rwd002-sitemap-category__item">
    <ul class="rwd002-sitemap-article">
      ${lis}
    </ul>
  </li>
</ul>`);
  };

  const parts = [];

  /** カテゴリ API なし → 料金型の単一 ul */
  if (catList.length === 0) {
    appendFlat(enriched.slice(0, ENTRY_WINDOW_SIZE));
    return parts.join('\n');
  }

  /** カテゴリ API あり → お知らせ型（先頭窓×カテゴリ） */
  const used = new Set();

  /** ENTRY 先頭 WINDOW 件の窓だけを対象に、カテゴリごとに抽出 */
  const windowRows = enriched.slice(0, ENTRY_WINDOW_SIZE);

  for (let i = 0; i < catList.length; i += 1) {
    const c = catList[i];
    const cid = String(c.id);
    const list = rowsForCategoryInWindow(windowRows, cid);
    if (!list.length) continue;
    appendBlock(cid, c.name != null ? String(c.name) : '', list);
    used.add(cid);
  }

  const idsInWindow = [...new Set(windowRows.map((a) => catIdOf(a)))];
  for (let i = 0; i < idsInWindow.length; i += 1) {
    const cid = idsInWindow[i];
    if (used.has(cid)) continue;
    const list = rowsForCategoryInWindow(windowRows, cid);
    if (!list.length) continue;
    const sample = list[0]._sitemapCat;
    const name = sample && sample.name ? sample.name : cid === '0' ? 'その他' : cid;
    appendBlock(cid, name, list);
    used.add(cid);
  }

  return parts.join('\n');
}

function findModuleSection(slug) {
  const sections = d.querySelectorAll('.rwd002-sitemap .rwd002-sitemap__contents');
  const needle = `/${slug}/`;
  for (let i = 0; i < sections.length; i += 1) {
    const el = sections[i];
    if (el.getAttribute('data-js-remote-injected') === '1') continue;
    const a = el.querySelector('h4.rwd002-sitemap__contents-title a, h4 a');
    if (!a) continue;
    const href = String(a.getAttribute('href') || '').split('?')[0].replace(/\/+$/, '') + '/';
    if (href.endsWith(needle) || href.includes(needle)) return el;
  }
  return null;
}

function injectHtml(sectionEl, html) {
  if (!sectionEl || !html || !String(html).trim()) return false;
  const h4 = sectionEl.querySelector('h4.rwd002-sitemap__contents-title') || sectionEl.querySelector('h4');
  if (h4) h4.insertAdjacentHTML('afterend', html);
  else sectionEl.insertAdjacentHTML('beforeend', html);
  sectionEl.setAttribute('data-js-remote-injected', '1');
  return true;
}

async function loadRemoteSections(mountEl) {
  const origin = (mountEl?.dataset?.apiOrigin || DEFAULT_API_ORIGIN).replace(/\/$/, '');

  const [voiceList, caseList, voiceCats, caseCats] = await Promise.all([
    TAGSORT.getArticleList({
      content: 'voice',
      post_per_page: -1,
      post_status: 'publish',
      sort: 'DESC',
      apiOrigin: origin,
    }).catch((e) => {
      console.warn(LOG, 'voice list failed', e?.message || e);
      return [];
    }),
    TAGSORT.getArticleList({
      content: 'case',
      post_per_page: -1,
      post_status: 'publish',
      sort: 'DESC',
      apiOrigin: origin,
    }).catch((e) => {
      console.warn(LOG, 'case list failed', e?.message || e);
      return [];
    }),
    TAGSORT.getCategories('voice', origin).catch((e) => {
      console.warn(LOG, 'voice categories failed', e?.message || e);
      return [];
    }),
    TAGSORT.getCategories('case', origin).catch((e) => {
      console.warn(LOG, 'case categories failed', e?.message || e);
      return [];
    }),
  ]);

  const voiceHtml = buildModuleSitemapHtml('voice', voiceList, voiceCats);
  const caseHtml = buildModuleSitemapHtml('case', caseList, caseCats);

  log('sizes', {
    voiceArticles: normalizeArticleList(voiceList).length,
    caseArticles: normalizeArticleList(caseList).length,
    voiceCats: normalizeCategories(voiceCats).length,
    caseCats: normalizeCategories(caseCats).length,
  });

  const voiceSection = findModuleSection('voice');
  const caseSection = findModuleSection('case');
  let okVoice = false;
  let okCase = false;
  if (voiceSection && voiceHtml) okVoice = injectHtml(voiceSection, voiceHtml);
  if (caseSection && caseHtml) okCase = injectHtml(caseSection, caseHtml);

  log('inject', { okVoice, okCase });

  if (mountEl && mountEl.parentNode) mountEl.remove();

  if (!okVoice && !okCase) {
    console.warn(
      LOG,
      'voice/case に挿入できる記事がありません（0件）、または対象ブロックが見つかりません。',
    );
  }
}

const domReady = () => {
  if (!isSitemapPage()) return;
  const mountEl = d.getElementById('js-sitemap-remote-root');
  loadRemoteSections(mountEl || null).catch((e) => {
    console.warn(LOG, 'loadRemoteSections error', e?.message || e);
  });
};

export default function SITEMAP() {
  if (listenerBound) return;
  listenerBound = true;
  d.addEventListener('rwd002.beforeDomready', () => domReady());
}
